import React from 'react'

// Components
import ImageStandard from 'components/flex/Image/ImageStandard'

interface ImageShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_PostTypes
  location?: any
}

interface PostProps {
  [key: string]: any
}

const ImageShell: React.FC<ImageShellProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    standard: ImageStandard,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default ImageShell
